import React, { useState } from "react";
import "./CoinPayment.css";

export default function CoinPayment() {
  const [version, setVersion] = useState("legacy");

  return (
    <div className="coin-container">
      {/* Breadcrumb */}
      <div className="breadcrumb">
        <span>Home</span> / <span>Payment Wallets</span> / <span>Create New</span>
      </div>

      {/* Title */}
      <h2 className="page-title">Create Payment Wallet</h2>

      {/* Card */}
      <div className="card">
        <div className="card-header">Coin Payment Configuration</div>
        <div className="card-body">
          {/* Version Selection */}
          <div className="form-group">
            <label className="form-label">Choose Version:</label>
            <div className="radio-group">
              <label>
                <input
                  type="radio"
                  value="legacy"
                  checked={version === "legacy"}
                  onChange={() => setVersion("legacy")}
                />
                CoinPayment Legacy Account
              </label>
              <label>
                <input
                  type="radio"
                  value="new"
                  checked={version === "new"}
                  onChange={() => setVersion("new")}
                />
                CoinPayment New Account
              </label>
            </div>
          </div>

          {/* Form Inputs */}
          <div className="form-row">
            <div className="form-col">
              <label>Public Key</label>
              <input type="text" placeholder="" />
            </div>
            <div className="form-col">
              <label>Private Key</label>
              <input type="text" placeholder="" />
            </div>
          </div>

          <div className="form-row">
            <div className="form-col">
              <label>Merchant ID</label>
              <input type="text" placeholder="" />
            </div>
            <div className="form-col">
              <label>Currency</label>
              <select>
                <option>USD</option>
                <option>EUR</option>
                <option>INR</option>
                <option>CAD</option>
                <option>AED</option>
                <option>AUD</option>
              </select>
            </div>
            <div className="form-col">
              <label>Activate IPN</label>
              <select>
                <option>Enable</option>
                <option>Disable</option>
              </select>
            </div>
            <div className="form-col">
              <label>IPN Secret</label>
              <input type="text" placeholder="" />
            </div>
            <div className="form-col">
              <label>IPN Debug Email</label>
              <input type="email" placeholder="" />
            </div>
            <div className="form-col">
              <label>Enable/Disable</label>
              <select>
                <option>Disable</option>
                <option>Enable</option>
              </select>
            </div>
          </div>

          {/* Button */}
          <div className="form-actions">
            <button className="btn-update">Update</button>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="footer">
        <span>
          Copyright © 2025 <b>Ample Markets</b>. All rights reserved.
        </span>
        <span className="version">Version 2.0</span>
      </div>
    </div>
  );
}
